export const scrollToTop = () => {
  setTimeout(() => {
    (window.top ?? window).scrollTo(0, 0);
    const elementMain = document.getElementById("main");
    const elementHeader = document.getElementById("header");
    const elementHeaderBanner = document.getElementById("header-banner");

    if (elementMain && !elementHeader) {
      elementMain.classList.add("p-top-0");
      elementMain.classList.remove("p-top-main");
      elementMain.classList.remove("p-top-main-w-banner");
    } else if (elementMain && elementHeader) {
      elementHeader.classList.remove("compact");
      if (!elementHeaderBanner) {
        elementMain.classList.add("p-top-main");
        elementMain.classList.remove("p-top-0");
      } else {
        elementMain.classList.add("p-top-main-w-banner");
        elementMain.classList.remove("p-top-0");
      }
      // based on this clientHeight apply CSS styles, don't use inline styles to avoid jitter
      // elementMain.style.paddingTop = `${elementHeader.clientHeight}px`;
    }
  });
};
